// extracted by mini-css-extract-plugin
export default {"tabContainer":"tab_tabContainer__DifsO","tab":"tab_tab__IFp3B","active":"tab_active__YnvOR"};